import { fetchJson } from '~/utils/fetch-json-v2';
import type { OrganizationsResponse } from './types';

export async function getUserOrganizationsApi() {
  return fetchJson<OrganizationsResponse>('/identities/me/orgs', {
    method: 'GET',
  });
}
